import styled from 'styled-components';
import { IonCard } from '@ionic/react';

export const IonCardWrapper = styled(IonCard)`
  .inout-label {
    margin-bottom: 10px;
    justify-content: space-evenly;

    ion-icon,
    ion-text {
      color: #8e8d8d;
      font-size: 14px;
    }

    ion-icon {
      margin-right: 3px;
    }
  }

  .disable-card {
    position: absolute;
    left: 0;
    top: 0;
    right: 0.01rem;
    bottom: 0;
    background-image: repeating-linear-gradient(45deg, #e5e5e5, #e5e5e5 30px, #dbdbdb 30px, #dbdbdb 60px);
  }

  .ro {
    font-size: 16px;
  }

  .status {
    font-size: 12px;
    color: var(--ion-color-tertiary);
    font-weight: bold;
  }

  .rego {
    font-size: 16px;
  }

  .vehicle {
    font-size: 12px;
    font-weight: bold;
  }

  .status-label {
    ion-badge {
      border-radius: 0;
      flex: 1 0 auto;
    }
  }

  .vehicle-col {
    border-left: 2px solid var(--ion-color-light);
    padding-left: 10px;
  }

  .veh-source {
    font-size: 12px;
    color: var(--ion-color-primarylight);
    font-weight: bold;
  }

  .ro-data {
    font-size: 12px;
    font-weight: bold;
    height: 20px;
    padding: 0 7px;
    margin-left: 2px;
    margin-right: 0;
  }
`;
